import PageTitle from "../../components/PageTitle";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from "primereact/button";
import PageContent from "../../components/PageContent";
import useApi from "../../hooks/ApiHook";
import { useEffect, useState } from "react";
import If from "../../components/If";
import Loading from "../../components/Loading";
import usePaginator from "../../hooks/PaginatorHook";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Tag } from 'primereact/tag';
import useToast from "../../hooks/ToastHook";

export default function() {

    const api = useApi();
    const toast = useToast();
    const navigate = useNavigate();
    const [ connections, setConnections ] = useState([]);
    const [ loading, setLoading ] = useState(true);
    const { page, limit, setTotal, Paginator } = usePaginator();
    const [ searchParams, setSearchParams ] = useSearchParams();
    
    useEffect(() => {
        retrieve();
    }, [page, limit]);

    const retrieve = () => {
        setLoading(true);
        api.get(`clients?page=${page}&limit=${limit}`).then(({ data }) => {
            setConnections(data.data);
            setTotal(data.total);
            setSearchParams({ page, limit });
        }).finally(() => setLoading(false));
    }

    const accept = (client) => {
        setLoading(true);
        api.put(`clients/${client.id}/relationship`, { status: 'ACTIVE' }).then(() => {
            toast.showSuccess('Conexão realizada com sucesso');
            retrieve();
        }).finally(() => {
            setLoading(false);
        });
    }

    const actions = client => client.status === 'WAITING' ? (
        <>
            <Button icon="pi pi-check" severity="success" title="Aceitar" onClick={() => accept(client)}/>
            <Button className="ml-2" severity="danger" icon="pi pi-times" title="Negar"/>
        </>
    ) : <></>;

    const statusColumnBody = (client) => client.status === 'WAITING'
        ? <Tag severity="warning" value="AGUARDANDO"/>
        : <Tag value="ATIVO"/>;

    return (
        <div>
            <PageTitle title="Clientes" subtitle="Veja e controle para quem seus produtos estão sendo vendidos"/>
            <PageContent>
                <If condition={loading}>
                    <Loading/>
                </If>
                <If condition={!loading}>
                    <DataTable value={connections} selectionMode="single" emptyMessage="Nada encontrado" responsiveLayout="stack">
                        <Column field="commercialName" header="Empresa"></Column>
                        <Column field="document" header="CPF/CNPJ"></Column>
                        <Column field="owner.commercialName" header="Responsável"></Column>
                        <Column body={statusColumnBody} header="Status"></Column>
                        <Column body={actions} header="Ações" align='right'></Column>
                    </DataTable>
                    <Paginator/>
                </If>
            </PageContent>
        </div>
    );
}